import axios from "./request";
//定义跨域代理路由
const currentUrl = window.location.href;
const regex = /www\./;
const mobil = /mobil\./;
const phone = mobil.test(currentUrl);
const iswww = regex.test(currentUrl);
// let api =
//   process.env.NODE_ENV == "development"
//     ? "/devapi"
//     : "http://140.179.61.9:8066/csi"; //new-测试
let  api = process.env.NODE_ENV == 'development' ? '/devapi' : 'https://www.csibizsearch.com/csi'//生产
// let api = process.env.NODE_ENV == 'development' ? '/devapi' :iswww?'https://www.csibizsearch.com/prod-api': 'https://csibizsearch.com/prod-api' //生产

// 产品搜索
export const getProductSearch = (params) => {
  return axios({
    isLoading: true,
    url: api + "/uboForCompany/productSearch",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
// 产品筛选
export const getProductFilter = (params) => {
  return axios({
    isLoading: true,
    url: api + "/uboForCompany/productFilterConditions",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
// 产品排序
export const getProductSortByColumns = (params) => {
  return axios({
    isLoading: true,
    url: api + "/uboForCompany/productSortByColumns",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};

// 公司搜索
export const getCompanySearch = (params) => {
  return axios({
    isLoading: true,
    url: api + "/company/search",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
// 公司筛选
export const getCompanyFilter = (params) => {
  return axios({
    isLoading: true,
    url: api + "/company/filters",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};

// 详情-Backgroud 关系图
export const getRelationChart = (params) => {
  return axios({
    isLoading: true,
    url: api + "/uboForCompany/getRelationChart",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};

// 详情-Ownership 点状关系图
export const getShareholderChart = (params) => {
  return axios({
    isLoading: true,
    url: api + "/uboForCompany/getShareholderChart",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
// 详情 Ownership/Investments 关系查询-1：股东     2：投资
export const getRelationshipInquiryOfHolder = (data) => {
  return axios({
    url: api + "/uboForCompany/getRelationshipInquiryOfHolder",
    method: "post",
    data,
  });
};
// 详情 Related Companies-关系查询
export const getCompanyRelationInquiry = (data) => {
  return axios({
    url: api + "/uboForCompany/getCompanyRelationInquiry",
    method: "post",
    data,
  });
};
// 详情 Supply Chain-关系查询
export const getRelationshipInquiryOfSusp = (data) => {
  return axios({
    url: api + "/uboForCompany/getRelationshipInquiryOfSusp",
    method: "post",
    data,
  });
};

// 详情-Investments 点状关系图
export const getInvestChart = (params) => {
  return axios({
    isLoading: true,
    url: api + "/uboForCompany/getInvestChart",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};

// 详情-Related Companies 点状关系图
export const getRelateChart = (params) => {
  return axios({
    isLoading: true,
    url: api + "/uboForCompany/getRelateChart",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};

// 详情-UBO Ruler
export const getShareholderDeepList = (params) => {
  return axios({
    isLoading: true,
    url: api + "/uboForCompany/getShareholderDeepList",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};

//详情-Supply Chain 供应链疑似主要供应商表单
export const getSuspectedCustomerList = (data) => {
  return axios({
    url: api + "/uboForCompany/getSuspectedCustomerList",
    method: "post",
    data,
  });
};
// 查询供应链业务链穿透
export const getBusinessChain = (params) => {
  return axios({
    isLoading: true,
    url: api + "/uboForCompany/getBusinessChain",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
